import { styled, Card } from '@/theme/index';

export const StyledApiUpgradeCtaCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin: 0 auto;
`;
